export default function ScaledCard({ width, children }) {
  const scale = width / 1080;
  return (
    <div className="scaled-card" style={{ width, height: 1920 * scale }}>
      <div style={{ width: 1080, height: 1920, transform: `scale(${scale})`, transformOrigin: "top left" }}>{children}</div>
    </div>
  );
}
